import { render, staticRenderFns } from "./AulaSearch.vue?vue&type=template&id=4f0d6fa5&scoped=true&"
import script from "./AulaSearch.vue?vue&type=script&lang=js&"
export * from "./AulaSearch.vue?vue&type=script&lang=js&"
import style0 from "./AulaSearch.vue?vue&type=style&index=0&id=4f0d6fa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d6fa5",
  null
  
)

export default component.exports